import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faLeaf,
  faLightbulb,
  faLock,
  faArrowLeft,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { useSwipeable } from "react-swipeable";

const Topics = () => {
  const topics = [
    {
      icon: faCheckCircle,
      title: "Excelência no Atendimento",
      description:
        "Priorizamos a satisfação do cliente, garantindo que cada interação seja única e memorável.",
    },
    {
      icon: faLeaf,
      title: "Sustentabilidade",
      description:
        "Comprometemo-nos a promover práticas de turismo sustentável, respeitando as comunidades locais e o meio ambiente.",
    },
    {
      icon: faLightbulb,
      title: "Inovação",
      description:
        "Estamos sempre em busca de novas tendências e experiências para oferecer aos nossos viajantes, garantindo que cada viagem seja uma aventura única.",
    },
    {
      icon: faLock,
      title: "Transparência",
      description:
        "Valorizamos a confiança e a honestidade, fornecendo informações claras e precisas para que nossos clientes possam tomar decisões informadas.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [animationDirection, setAnimationDirection] = useState("none");

  const handleNext = () => {
    setAnimationDirection("right");
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % topics.length);
      setAnimationDirection("none");
    }, 300);
  };

  const handlePrev = () => {
    setAnimationDirection("left");
    setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? topics.length - 1 : prevIndex - 1
      );
      setAnimationDirection("none");
    }, 300);
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: handlePrev,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true, // Enables swiping with mouse for testing
  });

  return (
    <div className="py-8">
      {/* Mobile View */}
      <div
        {...swipeHandlers}
        className="md:hidden flex items-center justify-center relative"
      >
        {/* Previous Arrow */}
        <button
          className="absolute left-2 text-cyan-600 p-2 rounded-full hover:bg-gray-200 focus:outline-none z-10"
          onClick={handlePrev}
        >
          <FontAwesomeIcon icon={faArrowLeft} size="2x" />
        </button>

        {/* Topic Content */}
        <div
          className={`relative w-72 md:w-80 p-6 bg-white border-2 border-cyan-600 rounded-lg shadow-lg text-center transition-transform duration-300 ease-in-out ${
            animationDirection === "right"
              ? "translate-x-full opacity-0"
              : animationDirection === "left"
              ? "-translate-x-full opacity-0"
              : "translate-x-0 opacity-100"
          }`}
        >
          <FontAwesomeIcon
            icon={topics[currentIndex].icon}
            size="3x"
            className="text-cyan-600 mb-4"
          />
          <h3 className="text-lg font-bold mb-4 text-cyan-600">
            {topics[currentIndex].title}
          </h3>
          <p className="text-gray-600">{topics[currentIndex].description}</p>
        </div>

        {/* Next Arrow */}
        <button
          className="absolute right-2 text-cyan-600 p-2 rounded-full hover:bg-gray-200 focus:outline-none z-10"
          onClick={handleNext}
        >
          <FontAwesomeIcon icon={faArrowRight} size="2x" />
        </button>
      </div>

      {/* Desktop Grid */}
      <div className="hidden md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {topics.map((topic, index) => (
          <div
            key={index}
            className="bg-white border-2 border-cyan-600 p-6 rounded-lg shadow-lg flex flex-col items-center"
          >
            <FontAwesomeIcon
              icon={topic.icon}
              size="3x"
              className="text-cyan-600 mb-4 mt-4"
            />
            <h3 className="text-lg font-bold mb-4 text-cyan-600 text-center">
              {topic.title}
            </h3>
            <p className="text-gray-600 text-center">{topic.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Topics;
